import axios from 'axios';
import { CURRENT_API_URL } from "../../../../Utils/Constants";
import notify from "../../../../Notifications/ToastifyActions";

function RefreshStoreCampaignService(token, storeIntegerID, refreshType) {
    return axios.post(`${CURRENT_API_URL}/campaign/manualRefreshCampaigns`, {
        integerID: storeIntegerID,
        refreshType: refreshType,
    }, {
        headers: {
            'Authorization': token,
        }
    })
        .then(() => {
            notify.NotifySuccess("Store campaigns refreshed successfully!");
            return true;
        })
        .catch(() => {
            notify.NotifyError("There was a problem refreshing store campaigns, please try again later.")
            return false;
        })
}

export default RefreshStoreCampaignService;